module.exports = __webpack_public_path__ + "static/bg_wall-c563900fa066cdfd8dbb4283a40c006b.png";